// @flow
import React from 'react';
import { commonMessages } from '../messages/Common';
import { injectIntl } from 'react-intl';
import type { IntlShape } from 'react-intl';

type Props = {
  noInsets?: boolean,
  intl: IntlShape,
};

const Skeleton = ({ noInsets, intl }: Props) => (
  <div
    className={`global-skeleton ${noInsets ? 'no-insets' : 'with-insets'}`}
    aria-label={intl.formatMessage(commonMessages.loading)}
    role="img"
  >
    <div className="global-skeleton-item" style={{ marginBottom: '2rem', width: '100%' }} />
    <div
      className="global-skeleton-item"
      style={{ marginBottom: '2rem', height: '2rem', width: '80%' }}
    />
    <div className="global-skeleton-item" style={{ marginBottom: '2rem', width: '60%' }} />
    <div className="global-skeleton-item" style={{ marginBottom: '2rem', width: '80%' }} />
    <div className="global-skeleton-item" style={{ marginBottom: '2rem', width: '40%' }} />
    <div className="global-skeleton-item" style={{ marginBottom: '2rem', width: '50%' }} />
    <div className="global-skeleton-item" style={{ marginBottom: '2rem', width: '60%' }} />
    <div className="global-skeleton-item" style={{ marginBottom: '2rem', width: '80%' }} />
    <div className="global-skeleton-item" style={{ marginBottom: '2rem', width: '50%' }} />
    <div className="global-skeleton-item" style={{ marginBottom: '2rem', width: '60%' }} />
    <div className="global-skeleton-item" style={{ marginBottom: '2rem', width: '80%' }} />
    <div className="global-skeleton-item" style={{ marginBottom: '2rem', width: '40%' }} />
    <div className="global-skeleton-item" style={{ marginBottom: '2rem', width: '50%' }} />
    <div className="global-skeleton-item" style={{ marginBottom: '2rem', width: '60%' }} />
    <div className="global-skeleton-item" style={{ marginBottom: '2rem', width: '80%' }} />
    <div className="global-skeleton-item" style={{ marginBottom: '2rem', width: '40%' }} />
    <div className="global-skeleton-item" style={{ marginBottom: '2rem', width: '50%' }} />
    <div className="global-skeleton-item" style={{ marginBottom: '2rem', width: '60%' }} />
    <div className="global-skeleton-item" style={{ marginBottom: '2rem', width: '80%' }} />
    <div className="global-skeleton-item" style={{ marginBottom: '2rem', width: '40%' }} />
    <div className="global-skeleton-item" style={{ marginBottom: '2rem', width: '50%' }} />
  </div>
);

export default injectIntl(Skeleton);
